/* eslint-disable @typescript-eslint/no-explicit-any */
import { take, toArray } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';

import { AutoTopUpBundleResolver } from '../auto-top-up-bundle/auto-top-up-bundle.resolver';
import { CreditBundlesResolver } from '../credit-bundles/credit-bundles.resolver';

@Injectable()
export class ManageAutoTopUpResolver {
  constructor(
    private readonly _autoTopUpBundleResolver: AutoTopUpBundleResolver,
    private readonly _creditBundlesResolver: CreditBundlesResolver
  ) {}

  public resolve(): Observable<any> {
    return concat(this._autoTopUpBundleResolver.resolve(), this._creditBundlesResolver.resolve()).pipe(take(2), toArray());
  }
}
